import { toolsSlice } from '~/store/tools/reducer'

export const { setActiveTool, setContinuousModeToggle, setOrthoModeToggle, setSnapToggle } = toolsSlice.actions

export default toolsSlice.reducer
